import './Player.css';

function Player(props) {
  return (
    <div className={"player " + (props.active ? "highlightPlayer": "")}>
      <input 
        type="text" 
        value={props.name} 
        minLength="1" 
        maxLength="10" 
        size="6" 
        onChange={props.onChange}/> : {props.score}
    </div>
  );
}

export default Player;
